import { ApiClient } from './client';
import { config } from '../config';

export interface FileUploadResponse {
  url: string;
  storagePath: string;
  fileSize?: number;
  contentType?: string;
  message: string;
}

class StorageService {
  constructor(private apiClient: ApiClient) {}

  async uploadFile(
    organizationId: string,
    fileType: string,
    file: File,
    agentKey?: string
  ): Promise<FileUploadResponse> {
    const formData = new FormData();
    formData.append('organizationId', organizationId);
    formData.append('fileType', fileType);
    formData.append('file', file);
    if (agentKey) {
      formData.append('agentKey', agentKey);
    }

    const response = await this.apiClient.post<FileUploadResponse>(
      '/api/storage/upload',
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    return response.data;
  }
}

// Create and export singleton instance
const storageService = new StorageService(new ApiClient(config.api.baseUrl));
export { storageService };
